import { AvailableIconTypes, IconType } from '@ui/Icon/types';
import { Actions, Subjects } from 'context/user/UserContext';
import { Flags } from '../../../FeatureFlags';

export interface DrawerNavItem {
  label: string;
  route: string;
  iconType: AvailableIconTypes;
  featureFlag?: Flags;
  disableLink?: boolean;
  additionalRoutes?: string[];
  ability?: { action: Actions; subject: Subjects };
}

export const routeIcons = {
  Projects: IconType.folder,
  Studio: IconType.studio,
  Voices: IconType.voices,
  'Voices V2': IconType.voices,
  Libraries: IconType.phonetic,
  API: IconType.codeSquare,
  Integrations: IconType.integrations,
};

export const routes: Array<DrawerNavItem> = [
  {
    route: '/dashboard/projects',
    label: 'Projects',
    iconType: IconType.folder,
    disableLink: false,
    additionalRoutes: ['/dashboard/workspaces'],
  },
  {
    route: '/dashboard/studio',
    label: 'Studio',
    iconType: IconType.studio,
  },
  {
    route: '/dashboard/avatars',
    label: 'Voices',
    iconType: IconType.voices,
    ability: { action: Actions.Read, subject: Subjects.PageVoices },
  },
  {
    route: '/dashboard/phonetic',
    label: 'Libraries',
    iconType: IconType.phonetic,
    ability: { action: Actions.Read, subject: Subjects.PageLibraries },
  },
  {
    route: '/dashboard/api',
    label: 'API',
    iconType: IconType.codeSquare,
    ability: { action: Actions.Read, subject: Subjects.PageApi },
  },
  {
    route: '/dashboard/integrations',
    label: 'Integrations',
    iconType: IconType.integrations,
    ability: { action: Actions.Read, subject: Subjects.PageIntegrations },
  },
];

export const secondaryRoutes: Array<DrawerNavItem> = [
  {
    route: 'https://help.wellsaid.io/',
    label: 'Help center',
    iconType: IconType.questionMarkCircle,
  },
  {
    route: 'https://www.wellsaid.io/resources/blog',
    label: 'Blog',
    iconType: IconType.lightbulb,
  },
  {
    route: '#',
    label: 'Send feedback',
    iconType: IconType.send,
    disableLink: true,
  },
];

export const breadcrumbRoutes: Array<DrawerNavItem> = [
  {
    route: '/dashboard/account',
    iconType: IconType.settings01,
    label: 'Account settings',
  },
];
